import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "contents-area cf" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "title-page" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = {
  key: 0,
  id: "FormCoupon"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "legend" }
const _hoisted_8 = { class: "form-row cf" }
const _hoisted_9 = { class: "fl-l label" }
const _hoisted_10 = { for: "Name" }
const _hoisted_11 = { class: "form-row cf" }
const _hoisted_12 = { class: "fl-l label" }
const _hoisted_13 = { for: "Name" }
const _hoisted_14 = { class: "form-row cf" }
const _hoisted_15 = { class: "fl-l label" }
const _hoisted_16 = { for: "Address" }
const _hoisted_17 = { class: "form-row cf" }
const _hoisted_18 = { class: "fl-l label" }
const _hoisted_19 = { for: "City" }
const _hoisted_20 = { class: "form-row cf" }
const _hoisted_21 = { class: "fl-l label" }
const _hoisted_22 = { for: "Province" }
const _hoisted_23 = { class: "form-row cf" }
const _hoisted_24 = { class: "fl-l label" }
const _hoisted_25 = { for: "Phone" }
const _hoisted_26 = { class: "form-row cf" }
const _hoisted_27 = { class: "fl-l label" }
const _hoisted_28 = { for: "Fax" }
const _hoisted_29 = { class: "form-row cf" }
const _hoisted_30 = { class: "fl-l label" }
const _hoisted_31 = { for: "Email" }
const _hoisted_32 = { class: "form-row cf" }
const _hoisted_33 = { class: "fl-l label" }
const _hoisted_34 = { for: "CouponMessage" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "form-row cf" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 0,
  class: "row validation-summary-errors"
}
const _hoisted_39 = { class: "cf" }
const _hoisted_40 = { class: "fl-l update-button" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 1,
  class: "success-box"
}
const _hoisted_43 = { class: "title-confirm" }

import { ref } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoRequest',
  props: {
    contentTitle: {},
    contentText: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const formData = ref<any>({ termsAgreement: false });
const validationErrors = ref<any[]>([]);
const isLoadingForm = ref(false);
const isSuccess = ref(false);

const routes = (window as any).App.routes;

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoadingForm.value = true;

    try {
        await Axios.post(routes.Contact_CouponPost, formData.value);
        GTagHelper.sendEvent("form_submit", "inforequest_form", "success");
        isSuccess.value = true;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(localizer).get("App.Common.QuoteRequest")), 1),
      _createElementVNode("div", _hoisted_4, [
        (!isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("fieldset", { disabled: isLoadingForm.value }, [
                _createElementVNode("legend", _hoisted_7, _toDisplayString(_unref(localizer).get("App.Common.ContactForm_Legend")), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(localizer).get("App.Common.Name")), 1),
                      _cache[11] || (_cache[11] = _createTextVNode()),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "required" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "Name",
                      name: "Name",
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Name') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.name,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(localizer).get("App.Common.Surname")), 1),
                      _cache[13] || (_cache[13] = _createTextVNode()),
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "required" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "Surname",
                      name: "Surname",
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.surname) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Surname') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.surname,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("App.Common.Address")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "Address",
                      name: "Address",
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.address) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Address') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.address,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(localizer).get("App.Common.City")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "City",
                      name: "City",
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.city) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('City') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.city,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("App.Common.Province")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "Province",
                      name: "Province",
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.province) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Province') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.province,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(localizer).get("App.Common.Phone")), 1),
                      _cache[15] || (_cache[15] = _createTextVNode()),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "required" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "Phone",
                      name: "Phone",
                      type: "tel",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.phone) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Phone') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.phone,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(localizer).get("App.Common.Fax")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "Fax",
                      name: "Fax",
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.fax) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Fax') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.fax,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(localizer).get("App.Common.Email")), 1),
                      _cache[17] || (_cache[17] = _createTextVNode()),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "required" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "Email",
                      name: "Email",
                      type: "email",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.email) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'fl-l textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.email,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(localizer).get("App.Common.Message")), 1)
                    ]),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "fl-l textarea",
                      cols: "20",
                      id: "CouponMessage",
                      name: "CouponMessage",
                      rows: "5",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.couponMessage) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        formData.value.couponMessage,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("fieldset", { disabled: isLoadingForm.value }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", {
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('TermsAgreement') }, 'fl-l radiobuttonlist'])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      name: "TermsAgreement",
                      id: "TermsAgreement",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.termsAgreement) = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        formData.value.termsAgreement,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _cache[19] || (_cache[19] = _createTextVNode("Ho letto l’", -1)),
                    _createElementVNode("a", {
                      href: _unref(routes).DataSecurity_PrivacyPolicy,
                      target: "_blank"
                    }, "informativa privacy", 8, _hoisted_37)
                  ], 2)
                ])
              ], 8, _hoisted_35),
              (validationErrors.value.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    disabled: isLoadingForm.value,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (submitForm())),
                    class: "button disable-on-submit"
                  }, _toDisplayString(_unref(localizer).get("App.Common.Send")), 9, _hoisted_41)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(localizer).get("App.Common.CouponSentConfirm_Title")), 1),
              _createTextVNode(" " + _toDisplayString(_unref(localizer).get("App.Common.CouponSentConfirm_Abstract")), 1)
            ]))
      ])
    ])
  ]))
}
}

})